import axios from "axios";

// For dev env
export const brogglBack = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_API,
  timeout: 300000,
});

// For staging env
// export const brogglBack = axios.create({
//   baseURL: 'https://broggl-back-staging-lb5a3zm7ta-ew.a.run.app/',
//   timeout: 60000
// })

// For prod env
// export const brogglBack = axios.create({
//   baseURL: 'https://broggl-back-lb5a3zm7ta-ew.a.run.app/',
//   timeout: 60000
// })
